__turbopack_context__.v({
  "avatar": "zIzOUG_avatar",
  "colorScheme--strong": "zIzOUG_colorScheme--strong",
  "container": "zIzOUG_container",
  "info": "zIzOUG_info",
  "linkDisabled": "zIzOUG_linkDisabled",
});
